export const biddersStates = {
  1: { label: 'Activo', color: 'success', icon: 'SearchIcon' },
  0: { label: 'Inactivo', color: 'gray', icon: 'EyeIcon' }
};
export const biddersStateCode = {
  activo: 1,
  inactivo: 0
};
